module.exports = __webpack_public_path__ + "static/media/dashboard.c425e7c9.jpg";